import React, { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash.debounce';
import DropdownTrigger from '@salesforce/design-system-react/module/components/menu-dropdown/button-trigger';
import DataTable from '@salesforce/design-system-react/module/components/data-table';
import DataTableColumn from '@salesforce/design-system-react/module/components/data-table/column';
import DataTableCell from '@salesforce/design-system-react/module/components/data-table/cell';
import DataTableInteractiveLink from '@salesforce/design-system-react/module/components/data-table/interactive-link';
import Icon from '@salesforce/design-system-react/module/components/icon';
import PageHeader from '@salesforce/design-system-react/module/components/page-header';
import { useDispatch, useSelector } from 'react-redux';
import UserSvg from '../../assets/users';
import { Button, ButtonGroup, Dropdown, PageHeaderControl } from '@salesforce/design-system-react';
import AddStandardUser from '../../components/Modal/addStandarduser';
import Input from '@salesforce/design-system-react/components/input';
import InputIcon from '@salesforce/design-system-react/components/icon/input-icon';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Tooltip from '@salesforce/design-system-react/components/tooltip';
import {
  getStandardUser,
  standardUsersSelector,
  updateStandardUserNotes,
} from '../../store/standardUsers/slice';
import { isEmpty } from '@firebase/util';
import moment from 'moment';
import ActionStandardUser from '../../components/Modal/actionStandarduser';
import { toast, Toaster } from 'react-hot-toast';
import { getTimeIntervalText } from '../../utilities/datetime';
import EditStandardUser from '../../components/Modal/editStandarduser';

const CustomWalletCell = ({ children, ...props }) => {
  const { item } = props;

  const openEditStandardUser = () => {
    props.setEditStandardUserModal(true);
    props.setUser(item);
  };

  return (
    <DataTableCell title={children} {...props}>
      <div onClick={() => openEditStandardUser()}>
        <span className="slds-m-right_xx-small">
          <UserSvg color={item.color || '#CCCCCC'} />
        </span>
        <DataTableInteractiveLink style={{ fontWeight: 'bold', color: '#080707' }}>
          {children}
        </DataTableInteractiveLink>
      </div>
    </DataTableCell>
  );
};

CustomWalletCell.displayName = DataTableCell.displayName;

const CustomDataTableNotes = ({ children, ...props }) => {
  const [editedValue, setEditedValue] = useState(children ? children : '');
  const dispatch = useDispatch();

  const addUpdateNotesHandler = (values) => {
    dispatch(values?.id && updateStandardUserNotes(values));
    // dispatch(getStandardUser());
  };

  const onCellEditData = (item, data) => {
    // setEditedValue(item);
    if (item === children) return;
    props.setShowToast(true);
    const values = {
      notes: item,
      id: data.item._id,
    };
    addUpdateNotesHandler(values);
  };

  return (
    <DataTableCell title={children ? children : 'Add note'} {...props}>
      <IconSettings iconPath="/assets/icons">
        <Input
          iconLeft={
            <InputIcon
              assistiveText={{
                icon: 'Search',
              }}
              name="edit"
              category="utility"
            />
          }
          type="text"
          value={editedValue}
          placeholder="Add note"
          onChange={(e) => {
            setEditedValue(e.target.value);
          }}
          className={`editable-cell-input tablenote`}
          onBlur={(e) => onCellEditData(e.target.value, props)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onCellEditData(e.target.value, props);
            }
          }}
          styleInput={{ border: '0px' }}
        />
      </IconSettings>
    </DataTableCell>
  );
};
CustomDataTableNotes.displayName = DataTableCell.displayName;

const CustomDataTableDate = ({ children, ...props }) => {
  return (
    <DataTableCell title={children} {...props}>
      {moment(children).format('MM/D/yyyy HH:mm:ss')}
    </DataTableCell>
  );
};
CustomDataTableDate.displayName = DataTableCell.displayName;

const CustomActionTableDate = ({ children, ...props }) => {
  const { item } = props;
  const suspend = item.status === true ? 'Suspend' : 'Enable';
  const pause = item.isSyncPaused === false ? 'Pause' : 'Resume';

  return (
    <DataTableCell title={'Actions'} {...props}>
      <Button
        className={`CustomButtonLarge ${
          suspend === 'Enable' ? 'action-enable-button' : 'action-suspend-button'
        }`}
        key={suspend}
        label={suspend}
        responsive
        variant="neutral"
        title={suspend === 'Enable' ? 'Allow user to sign in' : 'Stops user from signing in'}
        onClick={() =>
          props.setActionStandardUserModal({
            open: true,
            type: suspend,
            name: item.first_name,
            id: item._id,
            status: item.status,
            isSyncPaused: item.isSyncPaused,
          })
        }
      />
      <Button
        className="CustomButtonLarge action-pause-resume-button"
        key={pause}
        label={pause}
        responsive
        variant="neutral"
        title="Supend and pause sync"
        onClick={() =>
          props.setActionStandardUserModal({
            open: true,
            type: pause,
            name: item.first_name,
            id: item._id,
            status: item.status,
            isSyncPaused: item.isSyncPaused,
          })
        }
      />
      <Button
        className="CustomButtonLarge action-delete-button"
        key="Remove"
        label="Remove"
        responsive
        variant="text-destructive"
        title="Remove user and delete data"
        onClick={() =>
          props.setActionStandardUserModal({
            open: true,
            type: 'Remove',
            name: item.first_name,
            id: item._id,
          })
        }
      />
    </DataTableCell>
  );
};
CustomActionTableDate.displayName = DataTableCell.displayName;

const HedgeFund = () => {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const { loading, pagination, standardUsers, errors, success, message } =
    useSelector(standardUsersSelector);
  const [showToast, setShowToast] = useState(false);
  const [sortColumn, setSortColumn] = useState('');
  const [sortColumnDirection, setSortColumnDirection] = useState('');
  const [items, setItems] = useState([]);
  const [paginated, setPaginated] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [addStandardUserModal, setAddStandardUserModal] = useState(false);
  const [editStandardUserModal, setEditStandardUserModal] = useState(false);
  const [APICalledTime, setAPICalledTime] = useState(new Date());
  const [actionStandardUserModal, setActionStandardUserModal] = useState({
    open: false,
    type: '',
  });
  const [text, setText] = useState('Recently updated');
  const [searchText, setSearchText] = useState('');
  const [user, setUser] = useState({});

  useEffect(() => {
    dispatch(getStandardUser());
    // dispatch(suspendStandardUser());
  }, [dispatch]);

  useEffect(() => {
    setHasMore(true);
    if (standardUsers.length > 0) setItems(standardUsers);
    setAPICalledTime(new Date());
    const data = getTimeIntervalText(APICalledTime);
    setText(data);
  }, [standardUsers, dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      const data = getTimeIntervalText(APICalledTime);
      setText(data);
    }, 20000);

    return () => clearInterval(interval);
  }, [APICalledTime]);

  useEffect(() => {
    if (!showToast) return;
    success &&
      !loading &&
      toast.success(message, {
        id: 'standarduser-add-success',
        duration: 3000,
      });
    // setShowToast(false)

    !success &&
      !loading &&
      !isEmpty(errors) &&
      toast.error(errors, {
        id: 'standarduser-error',
        duration: 3000,
      });
  }, [success, errors, message, showToast, loading]);

  const controls = () => (
    <React.Fragment>
      <PageHeaderControl>
        <IconSettings iconPath="/assets/icons">
          <Input
            iconLeft={
              <InputIcon
                assistiveText={{
                  icon: 'Search',
                }}
                name="search"
                category="utility"
              />
            }
            id="search_text"
            placeholder="Search"
            value={searchText}
            onChange={(e) => onSearchText(e.target.value)}
            fixedTextRight={
              <Tooltip
                id="search-tooltip"
                align="top right"
                content="Search works on the basis of name and email"
                position="overflowBoundaryElement"
              />
            }
          />
        </IconSettings>
      </PageHeaderControl>
      {/* <PageHeaderControl>
        <Dropdown
          align="right"
          id="page-header-dropdown-object-home-content-right"
          options={[
            { label: 'Menu Item One', value: 'A0' },
            { label: 'Menu Item Two', value: 'B0' },
            { label: 'Menu Item Three', value: 'C0' },
            { type: 'divider' },
            { label: 'Menu Item Four', value: 'D0' },
          ]}
        >
          <DropdownTrigger>
            <Button
              assistiveText={{ icon: 'List View Controls' }}
              iconCategory="utility"
              iconName="settings"
              iconVariant="more"
            />
          </DropdownTrigger>
        </Dropdown>
      </PageHeaderControl> */}
      <PageHeaderControl>
        <Button
          assistiveText={{ icon: 'Refresh' }}
          iconCategory="utility"
          iconName="refresh"
          iconVariant="border-filled"
          variant="icon"
          onClick={() => {
            refreshTable();
          }}
        />
      </PageHeaderControl>
      {/* <PageHeaderControl>
        <ButtonGroup id="button-group-page-header-controls">
          <Button
            assistiveText={{ icon: 'Charts' }}
            iconCategory="utility"
            iconName="chart"
            iconVariant="border-filled"
            variant="icon"
          />
          <Button
            assistiveText={{ icon: 'Filters' }}
            iconCategory="utility"
            iconName="filterList"
            iconVariant="border-filled"
            variant="icon"
          />
        </ButtonGroup>
      </PageHeaderControl> */}
    </React.Fragment>
  );

  const handleSort = (sortColumn, ...rest) => {
    const { property, sortDirection } = sortColumn;
    setSortColumn(property);
    setSortColumnDirection(sortDirection);
    setItems([]);
    setHasMore(true);
    setIsPageLoading(false);
    setPaginated(0);
    dispatch(getStandardUser({ sort_column: property, sort_order: sortDirection }));

    // sorting will actually be handled from api
    // so dispatch sort action in useEffect
    // dispatch(sortAccounte({sortDirection, sortProperty}))
    // and the update the state with sorted accounts lists this will be done by above useEffect
  };

  const handleLoadMore = () => {
    if (!loading && !isPageLoading) {
      if (pagination?.hasNextPage) {
        setIsPageLoading(true);
        setPaginated(paginated + 1);
        setTimeout(() => {
          if (pagination.pages <= 1 || paginated >= pagination.pages || !pagination.hasNextPage) {
            setHasMore(false);
            setIsPageLoading(false);
            return;
          }

          if (pagination.currentPage >= pagination.pages) {
            setHasMore(false);
            setIsPageLoading(false);
            return;
          }
          let url = new URLSearchParams(pagination.nextPageUrl);

          dispatch(
            getStandardUser({
              limit: url.get('limit'),
              offset: url.get('offset'),
              q: searchText,
              sort_column: sortColumn,
              sort_order: sortColumnDirection,
            })
          );
          setIsPageLoading(false);
        }, 1000);
      } else {
        setIsPageLoading(false);
        setHasMore(false);
      }
    }
  };

  const refreshTable = () => {
    setHasMore(true);
    setPaginated(0);
    setItems([]);
    if (searchText !== '') {
      searchHandler(searchText);
    } else {
      dispatch(getStandardUser());
    }
  };

  const searchHandler = useCallback(
    debounce((values) => {
      setHasMore(true);
      setItems([]);
      setPaginated(0);
      dispatch(
        getStandardUser({
          q: values,
        })
      ).then((res) => setItems(res?.payload?.data));
      values === '' && dispatch(getStandardUser());
    }, 1000),
    []
  );

  const onSearchText = (value) => {
    setSearchText(value);
    searchHandler(value);
  };

  return (
    <>
      <div className="pageContent">
        <Toaster position="top-right" reverseOrder={false} />
        <PageHeader
          icon={<Icon assistiveText={{ label: 'Accounts' }} category="standard" name="account" />}
          info={`${items ? items.length : 0} items • ${text}`}
          joined
          btnLabel="Add Standard User"
          label="Standard Users"
          title={
            <h1 className="slds-page-header__title slds-p-right_x-small">
              <Dropdown id="page-header-dropdown-object-home-header">
                <DropdownTrigger>
                  <Button
                    className="slds-button_reset slds-type-focus"
                    iconCategory="utility"
                    iconName="down"
                    iconPosition="right"
                    label="All Standard User"
                    responsive
                    variant="base"
                  />
                </DropdownTrigger>
              </Dropdown>
            </h1>
          }
          onRenderActions={() => (
            <>
              <PageHeaderControl>
                <ButtonGroup id="button-group-page-header-actions">
                  <Button
                    onClick={() => setAddStandardUserModal(true)}
                    label={'Add Standard User'}
                  />
                </ButtonGroup>
              </PageHeaderControl>
            </>
          )}
          onRenderControls={controls}
          truncate
          variant="object-home"
        />

        <div style={{ height: `${standardUsers.length === 0 ? '100%' : 'calc(100vh - 220px)'}` }}>
          <DataTable
            assistiveText={{
              actionsHeader: 'actions',
              columnSort: 'sort this column',
              columnSortedAscending: 'asc',
              columnSortedDescending: 'desc',
              selectAllRows: 'Select all rows',
              selectRow: 'Select this row',
            }}
            fixedHeader
            fixedLayout
            items={items}
            id="Assets-Table"
            onSort={handleSort}
            hasMore={hasMore}
            onLoadMore={handleLoadMore}
            noRowHover
          >
            <DataTableColumn
              isSorted={sortColumn === 'name'}
              label="Name"
              property="name"
              sortable
              sortDirection={sortColumnDirection.name}
            >
              <CustomWalletCell
                setEditStandardUserModal={setEditStandardUserModal}
                setUser={setUser}
              />
            </DataTableColumn>
            <DataTableColumn
              isSorted={sortColumn === 'email'}
              label="Email"
              property="email"
              sortable
              sortDirection={sortColumnDirection.price}
            />
            <DataTableColumn
              isSorted={sortColumn === 'contact_number'}
              sortable
              isDefaultSortDescending
              label="Phone"
              property="contact_number"
              sortDirection={sortColumnDirection.contact_number}
            />
            <DataTableColumn label="Notes" property="notes">
              <CustomDataTableNotes setShowToast={setShowToast} />
            </DataTableColumn>
            <DataTableColumn
              isSorted={sortColumn === 'createdAt'}
              sortable
              label="Created Date"
              property="createdAt"
              sortDirection={sortColumnDirection.createdAt}
            >
              <CustomDataTableDate />
            </DataTableColumn>
            <DataTableColumn label="Action" width="22rem">
              <CustomActionTableDate setActionStandardUserModal={setActionStandardUserModal} />
            </DataTableColumn>
          </DataTable>

          {standardUsers.length === 0 && !hasMore && (
            <div className="nodatafound">
              <div>
                <img
                  src="/assets/empty-state/empty-folder.png"
                  alt=""
                  style={{ height: '150px' }}
                />
                <p style={{ textAlign: 'center', fontWeight: '700', fontSize: '20px' }}>
                  Data not available
                </p>
              </div>
            </div>
          )}
        </div>

        <AddStandardUser
          openModal={addStandardUserModal}
          closeModal={() => setAddStandardUserModal(false)}
        />

        <ActionStandardUser
          modelData={actionStandardUserModal}
          closeModal={setActionStandardUserModal}
        />

        <EditStandardUser
          openModal={editStandardUserModal}
          closeModal={() => setEditStandardUserModal(false)}
          user={user}
          type="standard"
        />
      </div>
    </>
  );
};

export default HedgeFund;
